import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
    selector: 'app-sensor-dialog',
    templateUrl: './sensor-dialog.component.html',
    styleUrls: ['./sensor-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SensorDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<SensorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readings: any[]
    ) {
      console.log(readings);
     }

onNoClick(): void {
    this.dialogRef.close();
  }
}
